/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * PwC Intelligent Tax Analytics API
 * OpenAPI spec version: 1.0
 */

export type FieldTypes = (typeof FieldTypes)[keyof typeof FieldTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldTypes = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
} as const;
